<template>
  <div>
    <router-view @open-dialog="openDialog"></router-view>
    <permission-cookie></permission-cookie>
    <el-dialog
      class="announcement-dialog"
      :title="detail.type === 1 ? 'Announcement' : ''"
      width="768px"
      :visible.sync="showContent"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <template v-if="detail.type === 1">
        <div class="title">
          {{ detail.title }}
        </div>
        <div class="content">
          {{ detail.content }}
        </div>
      </template>
      <div v-else  class="img-content">
        <img :src="detail.fileImgSrc" width="728px" height="auto" alt="">
      </div>
      <div v-if="detail.type === 1" slot="footer" style="text-align: center;">
        <el-button type="primary" @click="showContent=false" style="height:32px; line-height: 32px; padding: 0 20px;">OK</el-button>
      </div>
    </el-dialog>
    <check-code></check-code>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import PermissionCookie from './components/content/permissionCookie/Index'
import CheckCode from './components/content/checkCode'
export default {
  name: 'App',
  components: {
    PermissionCookie,
    CheckCode
  },
  data () {
    return {
      showContent: false,
      detail: {}
    }
  },
  async mounted () {
    const res = await this.getAnnounceApi()
    if (res) {
      this.showContent = true
      this.detail = res
    }
  },
  methods: {
    ...mapActions('announcement', [
      'getAnnounceApi'
    ]),
    async openDialog () {
      const res = await this.getAnnounceApi()
      if (res) {
        this.showContent = true
        this.detail = res
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
div
  height 100%
  weight 100%
.title
  line-height 14px
  margin-bottom 16px
.content
  line-height 16px
  color rgba(0,0,0, 0.5)
  height 180px
  word-break: break-all;
  overflow-y auto
.img-content
  max-height 480px
  overflow-y auto
.announcement-dialog
  >>> .el-dialog__body
    padding 10px 20px 30px 20px
</style>



// WEBPACK FOOTER //
// src/App.vue